"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('toggleColorMenuIsShown')(function toggleColorMenuIsShown(isShown, state) {
    var optionState = state.optionState;
    optionState.isColorMenuShown = isShown;
}));
//# sourceMappingURL=toggleColorMenuIsShown.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/actions/toggleColorMenuIsShown.js
// module id = 5151
// module chunks = 2